import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

import "./Banner.css";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ThemeContext } from "../../Contexts/ThemeContext";

// ✅ Desktop banners
import lgBanner1 from "../../Images/Banner1.png";


// ✅ Mobile banners
import mbBanner1 from "../../Images/bannermb1.png";


import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const Banner = () => {
  const { searchText, setSearchText } = useContext(ThemeContext);
  const isDesktop = window.innerWidth > 992;

  // ✅ Responsive image selection
  const banner01 = isDesktop ? lgBanner1 : mbBanner1;


  const currentDate = dayjs().tz("Asia/Dhaka");
  const offerStartTime = dayjs.tz("2024-12-31 23:59:00", "Asia/Dhaka");
  const offerEndTime = dayjs.tz("2025-01-10 23:59:00", "Asia/Dhaka");

  const offerValidity =
    currentDate.isAfter(offerStartTime) && currentDate.isBefore(offerEndTime);

  const navigate = useNavigate();

  return (
    <div>
      {/* ✅ Semantic landmark for better SEO */}
      <section aria-label="Featured Clariss Products Banner Slider">
        <Swiper
          spaceBetween={30}
          effect={"fade"}
          navigation={window.innerWidth >= 992}
          autoplay={{
            delay: 10000,
            disableOnInteraction: false,
          }}
          pagination={window.innerWidth < 700 ? false : { dynamicBullets: true }}
          modules={[Autoplay, EffectFade, Navigation, Pagination]}
          className="mySwiper h-auto"
        >

          <SwiperSlide>
            <Link to="/product-category/face wash">
              <img
                className="w-full h-auto z-10"
                src={banner01}
                alt="Clariss Gentle Face Wash – Refreshing skincare for glowing skin"
                width={isDesktop ? 1920 : 400}
                height={isDesktop ? 500 : 200}
                loading="lazy"
              />
            </Link>
          </SwiperSlide>

        </Swiper>
      </section>
    </div>
  );
};

export default Banner;
